import { memo as Memo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const AppJump = Memo(({ animate }) => {
	const rootRef = useRef(null);
	const flRef = useRef(null);
	const frRef = useRef(null);
	const hlRef = useRef(null);
	const hrRef = useRef(null);
	const animRef = useRef(null);

	useEffect(() => {
		const ctx = gsap.context(() => {
			const hlEl = hlRef.current;
			const hrEl = hrRef.current;
			const flEl = flRef.current;
			const frEl = frRef.current;
			if (!hlEl || !hrEl || !flEl || !frEl) return;

			const hlB = hlEl.getBBox();
			const hrB = hrEl.getBBox();
			const flB = flEl.getBBox();
			const frB = frEl.getBBox();
			const armY = 0.42;
			const hlOrigin = `${hlB.x + hlB.width} ${hlB.y + hlB.height * armY}`;
			const hrOrigin = `${hrB.x} ${hrB.y + hrB.height * armY}`;
			const flOrigin = `${flB.x + flB.width * 0.5} ${flB.y + 1}`;
			const frOrigin = `${frB.x + frB.width * 0.5} ${frB.y + 1}`;

			const tl = gsap.timeline({ paused: true });

			tl.to(rootRef.current, { duration: 0.2, y: -20 })
				.to(flRef.current, { duration: 0.2, svgOrigin: flOrigin, rotation: 30 }, 0)
				.to(frRef.current, { duration: 0.2, svgOrigin: frOrigin, rotation: -30 }, 0)
				.to(hlRef.current, { duration: 0.2, svgOrigin: hlOrigin, rotation: 24 }, 0)
				.to(hrRef.current, { duration: 0.2, svgOrigin: hrOrigin, rotation: -24 }, 0)
				.to(rootRef.current, { duration: 0.2, y: 0 }, 0.2)
				.to(flRef.current, { duration: 0.2, svgOrigin: flOrigin, rotation: 0 }, 0.2)
				.to(frRef.current, { duration: 0.2, svgOrigin: frOrigin, rotation: 0 }, 0.2)
				.to(hlRef.current, { duration: 0.2, svgOrigin: hlOrigin, rotation: 0 }, 0.2)
				.to(hrRef.current, { duration: 0.2, svgOrigin: hrOrigin, rotation: 0 }, 0.2);

			animRef.current = tl;
		}, rootRef);

		return () => ctx.revert();
	}, []);

	useEffect(() => {
		if (animate && animRef.current) {
			animRef.current.progress(0).play();
		}
	}, [animate]);

	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			ref={rootRef}
			className={`svg-max appJump`}
			viewBox='0 0 213.04 190.88'>
			<path
				ref={frRef}
				className={`appJump-fr defaultStyle`}
				d='M111.27,137.31c.45,5.03,1.45,32.14,2.18,40.81.38,4.5,3.47,8.31,7.81,9.6,1.58.47,3.17.94,4.75,1.41'
			/>
			<path
				ref={flRef}
				className={`appJump-fl defaultStyle`}
				d='M92.25,137.31c-.45,5.03-1.45,32.14-2.18,40.81-.38,4.5-3.47,8.31-7.81,9.6-1.58.47-3.17.94-4.75,1.41'
			/>
			<rect
				className='fill'
				x='28.78'
				width='154.46'
				height='154.46'
			/>
			<path
				ref={hlRef}
				className={`appJump-hl defaultStyle`}
				d='M28.78,95.74c-2.89,3.7-7.44,16.68-16.69,14.12-9.39-2.59-3.21-39.12-10.33-33.18'
			/>
			<path
				ref={hrRef}
				className={`appJump-hr defaultStyle`}
				d='M211.29,72.51c-4.39,1.67-7.94,26.6-17.53,26.13-7.75-.37-13.24-7.85-17.22-9.51'
			/>
		</svg>
	);
});

export default AppJump;
